<template>
	<NuxtLink
		:id="SERVICE_AREAS_CITY_CARD_COMPONENT_ID"
		:to="cardActive ? serviceArea.link : ''"
		class="overflow-visible rounded-xl shadow-lg hover:shadow-xl border-b-8 border-(--ui-bg) hover:border-primary bg-default transition duration-150 ease-in-out group"
		@click="trackEvent($event, trackingLocation, {
			service_area: serviceArea.title
		})"
		@mouseenter="trackEvent($event, trackingLocation, {
			service_area: serviceArea.title
		})"
		@focus="trackEvent($event, trackingLocation, {
			service_area: serviceArea.title
		})"
	>
		<div :class="imageClasses">
			<img
				:src="`${serviceArea?.image?.filename}/m/324x162`"
				:srcset="`${serviceArea?.image?.filename}/m/280x140 324w, ${serviceArea?.image?.filename}/m/432x216 500w, ${serviceArea?.image?.filename}/m/500x250 800w, ${serviceArea?.image?.filename}/m/620x310 1000w`"
				sizes="(max-width: 640px) 720px, (max-width: 1024px) 400px, (max-width: 1600px) 720px, 500px"
				loading="lazy"
				:alt="serviceArea?.image?.alt"
				class="rounded rounded-t-lg group-hover:opacity-75 transition duration-150 ease-in-out w-full"
			>
		</div>
		<div class="flex flex-col items-center content-center w-full h-16 p-4 text-center justify-evenly">
			<div class="self-center font-semibold text-xl text-highlighted">
				{{ serviceArea?.title }}
			</div>
			<div
				v-if="serviceArea?.comingSoon"
				class="text-sm font-semibold text-green-500 uppercase"
			>
				{{ serviceArea?.comingSoonText }}
			</div>
		</div>
	</NuxtLink>
</template>

<script setup lang="ts">
import { useGA4Tracking } from '@/composables/useGA4Tracking'
import { SERVICE_AREAS_CITY_CARD_COMPONENT_ID } from '@/constants/ga4/tracking-ids'

defineProps({
	serviceArea: {
		type: Object,
		required: true
	},
	imageClasses: {
		type: String,
		default: 'h-44 aspect-w-16 aspect-h-9 m-2'
	},
	cardActive: {
		type: Boolean,
		default: true
	},
	trackingLocation: {
		type: String,
		default: ''
	}
})

const { trackEvent } = useGA4Tracking()
</script>
